/* TDP photo swatches: turns each colour swatch into a close-up of the real dress fabric,
   and makes the main product photo switch to the right colour when a swatch is picked.
   For each product:
   1. A colour with its own photo (named after the colour, or linked to it in Shopify) uses
      that photo, as long as the photo really shows that colour.
   2. Otherwise the product's photos are sorted by colour: every photo is scored against every
      colour name and belongs to the colour it matches best. The best photo for each colour
      becomes its swatch and the photo the gallery jumps to.
   3. If no photo shows the colour, a plain circle in a realistic shade for the colour name is shown.
   The close-up itself is the patch of the photo made up almost entirely of the dress colour
   (avoiding skin, legs in slits, arms and background). */
(function () {
  if (window.__tdpPhotoSwatches) return;
  window.__tdpPhotoSwatches = true;

  var ZOOM = 7; // must match background-size: 700% in snippets/swatch.liquid
  var BIN = 32; // colour histogram bucket size
  var SKIN_OK = /(nude|champ|gold|blush|beige|peach|tan|bronze|rose|taupe|caramel|latte|mocha|sand|almond|toffee|coffee|copper|apricot|dusty|mauve|oyster|biscuit|camel|khaki|coral|salmon|brown|cinnamon|cognac|honey|mustard)/i;

  // approximate colours for common dress colour words
  var HINTS = {
    black: [20, 20, 22], white: [245, 245, 245], ivory: [240, 234, 214], cream: [240, 228, 200], pearl: [234, 228, 220],
    silver: [190, 190, 195], grey: [128, 128, 130], gray: [128, 128, 130], charcoal: [60, 60, 65], graphite: [70, 70, 75],
    gunmetal: [80, 82, 88], pewter: [140, 140, 140], platinum: [215, 213, 208], steel: [110, 125, 140],
    champagne: [222, 200, 165], champ: [222, 200, 165], nude: [215, 175, 145], beige: [215, 195, 165], sand: [205, 185, 150],
    oyster: [215, 205, 190], taupe: [150, 130, 115], khaki: [175, 160, 120], tan: [195, 160, 120], camel: [190, 150, 100],
    latte: [190, 160, 130], mocha: [135, 100, 80], coffee: [120, 85, 60], brown: [110, 70, 45], chocolate: [80, 50, 35],
    caramel: [190, 130, 70], toffee: [170, 110, 60], cinnamon: [160, 90, 50], rust: [165, 75, 40], terracotta: [190, 95, 70],
    copper: [185, 110, 70], bronze: [165, 115, 60], gold: [210, 175, 90], mustard: [200, 160, 50], yellow: [240, 215, 70],
    lemon: [245, 235, 120], marigold: [235, 165, 40], sunflower: [240, 190, 40], orange: [240, 130, 40], tangerine: [245, 125, 50],
    apricot: [245, 175, 130], peach: [245, 185, 155], coral: [245, 120, 100], salmon: [240, 140, 120], melon: [245, 170, 140],
    red: [190, 25, 35], scarlet: [215, 30, 30], crimson: [180, 20, 50], ruby: [160, 15, 50], cherry: [170, 20, 40],
    wine: [110, 25, 45], burgundy: [110, 20, 40], maroon: [100, 25, 35], berry: [140, 35, 80], raspberry: [190, 40, 90],
    pink: [240, 170, 190], blush: [240, 200, 200], rose: [220, 150, 160], dusty: [200, 150, 155], fuchsia: [210, 30, 130],
    magenta: [200, 30, 150], hot: [240, 60, 150], candy: [245, 140, 180], bubblegum: [245, 150, 190],
    mauve: [180, 130, 150], lilac: [195, 165, 210], lavender: [185, 170, 220], orchid: [200, 120, 200], violet: [140, 80, 180],
    purple: [110, 50, 140], plum: [110, 40, 90], grape: [100, 40, 110], eggplant: [70, 35, 70], aubergine: [70, 35, 70],
    periwinkle: [150, 160, 230], blue: [50, 90, 190], royal: [40, 70, 180], cobalt: [30, 60, 170], sapphire: [20, 50, 140],
    navy: [25, 35, 80], midnight: [25, 30, 60], sky: [140, 190, 235], baby: [165, 205, 240], powder: [175, 205, 230],
    ice: [195, 220, 240], aqua: [110, 210, 215], turquoise: [60, 200, 200], teal: [20, 120, 130], seafoam: [150, 220, 190],
    mint: [175, 230, 200], sage: [160, 180, 150], olive: [110, 115, 60], green: [40, 140, 70], emerald: [10, 110, 70],
    jade: [30, 150, 110], forest: [30, 80, 45], hunter: [40, 80, 50], bottle: [20, 75, 50], lime: [170, 220, 60]
  };

  var MODIFIERS = { hot: 1, baby: 1, ice: 1, royal: 1, sky: 1, powder: 1, dusty: 1, candy: 1, bubblegum: 1, bottle: 1, hunter: 1, forest: 1, midnight: 1, steel: 1 };

  function hintsFor(name) {
    // the last recognised word is the base colour ("Silver Pink" is a pink dress, "Red AB" is red)
    // shade words like "hot" pink / "ice" blue / "royal" blue take priority over the base word
    var words = String(name || '').toLowerCase().split(/[^a-z]+/);
    for (var i = words.length - 1; i >= 0; i--) {
      if (HINTS[words[i]]) {
        if (i > 0 && MODIFIERS[words[i - 1]] && HINTS[words[i - 1]]) return [HINTS[words[i - 1]]];
        return [HINTS[words[i]]];
      }
    }
    return [];
  }

  function isSkin(r, g, b) {
    if (!(r > g && g >= b * 0.9)) return false;
    var mx = r, mn = Math.min(g, b);
    if (mx < 70) return false;
    var s = (mx - mn) / mx;
    if (s < 0.12 || s > 0.68) return false;
    var h = 60 * ((g - b) / (mx - mn));
    return h >= 0 && h <= 42;
  }

  // colour distance that cares more about tint than brightness
  function dist2(r, g, b, ref) {
    var dL = (r + g + b) / 3 - (ref[0] + ref[1] + ref[2]) / 3;
    var dc1 = (r - g) - (ref[0] - ref[1]), dc2 = (g - b) - (ref[1] - ref[2]);
    return 0.5 * dL * dL + 3 * (dc1 * dc1 + dc2 * dc2);
  }

  var cache = {};

  function analyse(src, name, findMode, shared) {
    var key = src + '|' + name + '|' + findMode + '|' + shared;
    if (cache[key]) return cache[key];
    cache[key] = new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        try {
          var W = img.naturalWidth, H = img.naturalHeight;
          var cv = document.createElement('canvas');
          cv.width = W; cv.height = H;
          var ctx = cv.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0);
          var d = ctx.getImageData(0, 0, W, H).data;
          var allowSkin = SKIN_OK.test(name || '');
          var hints = hintsFor(name);
          // a photo shared by several colours (group shot / general photo): search the whole width
          var wide = hints.length > 0 && shared;
          var xLo = wide ? 0.08 : 0.3, xHi = wide ? 0.92 : 0.7;

          function bin(r, g, b) { return ((r / BIN) | 0) * 64 + ((g / BIN) | 0) * 8 + ((b / BIN) | 0); }

          // 1. colour histograms: edges (background) vs middle (model + dress)
          var edge = {}, edgeN = 0, mid = {}, midN = 0, sums = {};
          var ew = Math.max(2, Math.round(W * 0.06));
          for (var y = 0; y < H; y++) {
            for (var x = 0; x < W; x++) {
              var i = (y * W + x) * 4, r = d[i], g = d[i + 1], b = d[i + 2], k = bin(r, g, b);
              if (x < ew || x >= W - ew) { edge[k] = (edge[k] || 0) + 1; edgeN++; }
              if (x > W * xLo && x < W * xHi && y > H * 0.2 && y < H * 0.9) {
                var wt = 1;
                if (isSkin(r, g, b)) {
                  if (!allowSkin) continue;
                  wt = 0.4; // skin-like dress colours are allowed, but real skin shouldn't dominate
                }
                mid[k] = (mid[k] || 0) + wt; midN += wt;
                var s = sums[k] || (sums[k] = [0, 0, 0]);
                s[0] += r * wt; s[1] += g * wt; s[2] += b * wt;
              }
            }
          }

          var bestK = null, bestV = -Infinity, bestHintD = Infinity;
          Object.keys(mid).forEach(function (k) {
            var f = mid[k] / midN;
            if (f < 0.004) return;
            var v = f - (hints.length ? 0.6 : 1.5) * ((edge[k] || 0) / edgeN);
            var mean = sums[k].map(function (t) { return t / mid[k]; });
            var hd = Infinity;
            if (hints.length) {
              hints.forEach(function (h) { hd = Math.min(hd, dist2(mean[0], mean[1], mean[2], h)); });
              // strongly prefer colours near the named colour
              v = Math.max(v, 0.002) * Math.exp(-hd / (2 * 55 * 55));
            }
            if (v > bestV) { bestV = v; bestK = k; bestHintD = hd; }
          });
          if (bestK === null) { resolve(null); return; }
          // in "find" mode the photo isn't specific to this colour: give up if the colour isn't there
          if (findMode && (!hints.length || bestHintD > 50 * 50)) { resolve({ none: true }); return; }

          var ref = sums[bestK].map(function (t) { return t / mid[bestK]; });

          // colours more typical of the photo edges than the middle = background
          var isBg = {};
          // when the photo clearly contains the named colour, trust it even if it touches the edges
          // (e.g. the girl on the end of a group photo)
          if (!(hints.length && bestHintD < 80 * 80)) Object.keys(edge).forEach(function (k) {
            if (edge[k] / edgeN > 0.8 * ((mid[k] || 0) / Math.max(1, midN))) isBg[k] = true;
          });
          isBg[bestK] = false;

          // 2. find the patch made up mostly of the dress colour
          var pw = Math.max(4, Math.round(W / ZOOM));
          var T2 = 40 * 40;
          var best = null, bestScore = -Infinity, bestFrac = 0;
          for (var cy = 0.22; cy <= 0.881; cy += 0.03) {
            for (var cx = xLo; cx <= xHi + 0.001; cx += 0.03) {
              var x0 = Math.round(cx * W - pw / 2), y0 = Math.round(cy * H - pw / 2);
              var hit = 0, n = 0, sL = 0, sL2 = 0;
              for (var yy = y0; yy < y0 + pw; yy++) {
                if (yy < 0 || yy >= H) continue;
                for (var xx = x0; xx < x0 + pw; xx++) {
                  if (xx < 0 || xx >= W) continue;
                  var j = (yy * W + xx) * 4;
                  var LL = (d[j] + d[j + 1] + d[j + 2]) / 3;
                  sL += LL; sL2 += LL * LL;
                  if (dist2(d[j], d[j + 1], d[j + 2], ref) < T2 && !isBg[bin(d[j], d[j + 1], d[j + 2])]) hit++;
                  n++;
                }
              }
              if (!n) continue;
              var frac = hit / n;
              // small bonus for texture (sequins/beading) so smooth skin loses a tie with fabric
              var tex = Math.min(1, Math.sqrt(Math.max(0, sL2 / n - (sL / n) * (sL / n))) / 25);
              var score = frac * (1 + 0.15 * tex) - Math.abs(cx - 0.5) * (wide ? 0.15 : 0.4) - Math.abs(cy - 0.5) * 0.2;
              if (score > bestScore) { bestScore = score; best = { cx: cx, cy: cy }; bestFrac = frac; }
            }
          }
          if (findMode && bestFrac < 0.45) { resolve({ none: true }); return; }
          resolve(best ? { cx: best.cx, cy: best.cy, ratio: H / W, ref: ref, hd: bestHintD, frac: bestFrac, hinted: hints.length > 0, v: bestV } : null);
        } catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = src;
    });
    return cache[key];
  }

  function smallUrl(u) {
    return /width=\d+/.test(u) ? u.replace(/width=\d+/, 'width=160') : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  // Is this result believable for a swatch called `name`?
  function believable(res, name, find) {
    if (!res || res.none) return false;
    if (!res.hinted) return !find; // unknown colour word: trust the colour's own photo, never a general one
    var lim = find ? 50 : 85;
    if (res.hd > lim * lim) return false; // fabric found is too far from the named colour
    if (!SKIN_OK.test(name) && isSkin(res.ref[0], res.ref[1], res.ref[2])) return false; // landed on skin
    if (res.frac < 0.35) return false; // patch isn't mostly one fabric
    return true;
  }

  // Try the colour's own photo first, then the product's other photos, and return the first
  // believable close-up: { src, res } - or null, meaning "show the plain colour".
  function resolveSwatch(full, name, findMode, shared, alts) {
    var tries = [{ src: full, find: findMode, shared: shared }];
    (alts || []).forEach(function (u) { if (u && u !== full) tries.push({ src: u, find: true, shared: true }); });
    var i = 0;
    function next() {
      if (i >= tries.length) return Promise.resolve(null);
      var t = tries[i++];
      return analyse(smallUrl(t.src), name, t.find, t.shared).then(function (res) {
        return believable(res, name, t.find) ? { src: t.src, res: res } : next();
      });
    }
    return next();
  }
  window.__tdpResolve = resolveSwatch;

  // No photo shows this colour: show a plain circle in a realistic shade for the colour name
  // (instead of the browser's pure CSS colour, e.g. bright #0000FF for "Blue").
  function plain(el) {
    el.style.backgroundImage = 'none';
    var h = hintsFor(el.getAttribute('data-tdp-name'));
    if (h.length) el.style.backgroundColor = 'rgb(' + h[0].join(',') + ')';
    el.setAttribute('data-tdp-plain', '');
  }

  function apply(el, src, res) {
    var iw = ZOOM, ih = ZOOM * res.ratio;
    var bx = (res.cx * iw - 0.5) / (iw - 1);
    var by = (res.cy * ih - 0.5) / (ih - 1);
    bx = Math.min(1, Math.max(0, bx)); by = Math.min(1, Math.max(0, by));
    el.style.backgroundImage = 'url("' + src + '")';
    el.style.backgroundPosition = (bx * 100).toFixed(1) + '% ' + (by * 100).toFixed(1) + '%';
  }

  // When the colour has no photo linked to it in Shopify, tell the theme which gallery photo shows
  // this colour, so the main image switches when the colour is picked (the theme reads
  // data-option-value-featured-media from the clicked input).
  function linkGallery(el, mediaId, index) {
    if (!mediaId) return;
    var label = el.closest('label');
    var input = label && label.querySelector('[js-variant-input]');
    if (!input) return;
    if (input.getAttribute('data-option-value-featured-media') && !input.hasAttribute('data-tdp-linked')) return; // merchant's own link wins
    input.setAttribute('data-option-value-featured-media', mediaId);
    if (index >= 0) input.setAttribute('data-option-value-featured-media-position', String(index + 1));
    input.setAttribute('data-tdp-linked', '');
    if (label.querySelector('.swatch--selected')) showColourPhoto(input);
  }

  // Move the product gallery to the photo of the selected colour. The theme only does this itself
  // when the photo is linked to the variant in Shopify.
  var lastShown = { gallery: null, media: null };
  function showColourPhoto(input) {
    var mediaId = input.getAttribute('data-option-value-featured-media');
    var gallery = document.querySelector('product-media');
    if (!mediaId || !gallery || typeof gallery.updateActiveMainMediaToVariant !== 'function') return;
    if (gallery.getAttribute('data-media-layout') === 'columns') return; // every photo is already on screen
    if (!gallery.querySelector('[data-media-item-id="' + mediaId + '"]')) return;
    if (lastShown.gallery === gallery && lastShown.media === mediaId) return;
    lastShown = { gallery: gallery, media: mediaId };
    // let the theme finish building the new gallery first
    setTimeout(function () {
      try { gallery.updateActiveMainMediaToVariant({ detail: { newFeaturedMedia: mediaId } }); } catch (e) {}
    }, 150);
  }

  function showSelectedColour() {
    // (colour and size radios share one group, so use the highlighted swatch, not :checked)
    var sw = document.querySelector('.option-group__swatches-container .swatch--selected');
    var input = sw && sw.closest('label') && sw.closest('label').querySelector('[js-variant-input][data-option-value-featured-media]');
    if (input) showColourPhoto(input);
  }

  function parseAlts(str) {
    var ids = {}, urls = [];
    (str || '').split('|').forEach(function (a) {
      if (!a) return;
      var k = a.indexOf('~');
      var u = k < 0 ? a : a.slice(k + 1);
      if (k >= 0) ids[u] = a.slice(0, k);
      urls.push(u);
    });
    return { ids: ids, urls: urls };
  }

  // All the colour swatches of one product are worked out together.
  function placeGroup(els) {
    var gal = parseAlts(els[0].getAttribute('data-tdp-alts'));
    var names = els.map(function (el) { return el.getAttribute('data-tdp-name') || ''; });
    var photoCount = {};
    els.forEach(function (el) { var f = el.getAttribute('data-tdp-photo'); photoCount[f] = (photoCount[f] || 0) + 1; });

    // Step 1: colours with their own photo (named after the colour, or linked in Shopify):
    // use it if it really shows that colour.
    var pending = [];
    var firsts = els.map(function (el, n) {
      var full = el.getAttribute('data-tdp-photo');
      var find = el.getAttribute('data-tdp-mode') === 'find';
      if (find || !full) { pending.push(n); return Promise.resolve(); }
      var shared = photoCount[full] > 1;
      return analyse(smallUrl(full), names[n], false, shared).then(function (res) {
        if (believable(res, names[n], false)) {
          apply(el, full, res);
          linkGallery(el, gal.ids[full], gal.urls.indexOf(full));
        } else {
          pending.push(n);
        }
      });
    });

    return Promise.all(firsts).then(function () {
      if (!pending.length) return;
      if (!gal.urls.length) { pending.forEach(function (n) { plain(els[n]); }); return; }

      // Single-colour product: every photo is that colour.
      if (names.length === 1) {
        var n0 = pending[0];
        return analyse(smallUrl(gal.urls[0]), names[n0], false, false).then(function (res) {
          if (res && !res.none) { apply(els[n0], gal.urls[0], res); } else { plain(els[n0]); }
        });
      }

      // Step 2: sort the product's photos by colour. Each photo is scored against every colour
      // name; a photo belongs to the colour it matches best. This copes with muted shades
      // (a dusty "pink" or soft "blue") because it only compares the product's own colours.
      // a photo whose file name names one of this product's colours only counts for that colour
      var keyOf = function (t) { return String(t).toLowerCase().replace(/[^a-z]/g, ''); };
      var nameKeys = names.map(keyOf);
      var fileOf = function (u) { return keyOf(u.split('?')[0].split('/').pop().split('_')[0]); };
      var allowed = function (p, c) {
        var f = fileOf(gal.urls[p]);
        var mine = nameKeys[c] && f.indexOf(nameKeys[c]) > -1;
        if (mine) return true;
        for (var o = 0; o < nameKeys.length; o++) {
          if (o !== c && nameKeys[o].length > 2 && f.indexOf(nameKeys[o]) > -1 && nameKeys[c].indexOf(nameKeys[o]) < 0) return false;
        }
        return true;
      };
      var jobs = [];
      var score = gal.urls.map(function () { return names.map(function () { return null; }); });
      gal.urls.forEach(function (u, p) {
        names.forEach(function (nm, c) {
          if (!allowed(p, c)) return;
          jobs.push(analyse(smallUrl(u), nm, false, true).then(function (res) { score[p][c] = res && !res.none && res.hinted ? res : null; }));
        });
      });
      return Promise.all(jobs).then(function () {
        var owner = score.map(function (row) {
          var bc = -1, bv = 0;
          row.forEach(function (r, c) { if (r && r.v > bv) { bv = r.v; bc = c; } });
          return bc;
        });
        pending.forEach(function (c) {
          var el = els[c], bestP = -1, bestV = 0;
          // best photo that belongs to this colour
          owner.forEach(function (o, p) { var r = score[p][c]; if (o === c && r && r.v > bestV) { bestV = r.v; bestP = p; } });
          // otherwise (e.g. group shots) the photo where this colour is clearest, if it's close enough
          if (bestP < 0) {
            score.forEach(function (row, p) { var r = row[c]; if (r && r.hd < 60 * 60 && r.frac >= 0.45 && r.v > bestV) { bestV = r.v; bestP = p; } });
          }
          if (bestP < 0) { plain(el); return; }
          var src = gal.urls[bestP], res = score[bestP][c];
          if (!SKIN_OK.test(names[c]) && isSkin(res.ref[0], res.ref[1], res.ref[2])) { plain(el); return; }
          apply(el, src, res);
          linkGallery(el, gal.ids[src], bestP);
        });
      });
    });
  }

  window.__tdpPlaceGroup = placeGroup; // used by the store-wide swatch check

  function scan() {
    var groups = {};
    document.querySelectorAll('[data-tdp-photo]').forEach(function (el) {
      if (el.__tdpDone) return;
      el.__tdpDone = true;
      var key = el.getAttribute('data-tdp-alts') || el.getAttribute('data-tdp-photo');
      (groups[key] = groups[key] || []).push(el);
    });
    Object.keys(groups).forEach(function (k) { placeGroup(groups[k]); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { scan(); showSelectedColour(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();